import AbstractCalls from "./AbstractCalls";

class MerchandiseCalls extends AbstractCalls {
  create(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "merchandise/create");
    return AbstractCalls.post(cmdUri, body, options);
  }

  update(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "merchandise/update");
    return AbstractCalls.put(cmdUri, body, options);
  }

  delete(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "merchandise/delete");
    return AbstractCalls.delete(cmdUri, body, options);
  }

  setAvailability(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "merchandise/setAvailability");
    return AbstractCalls.post(cmdUri, body, options);
  }

  get(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "merchandise/get");
    return AbstractCalls.get(cmdUri, body, options);
  }

  list(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "merchandise/list");
    return AbstractCalls.get(cmdUri, body, options);
  }
}

export default new MerchandiseCalls();
